import { Set } from 'immutable';

import { MAX_NUMBER_OF_FILES, MAX_NUMBER_OF_VIDEOS } from '@/constants/validations';
import { EBAY, ETSY, SHOPIFY } from '@/constants/channels';
import { ATTRIBUTE } from '@/constants/attributes';

export const THUMBNAIL_SIZE = 120;
export const THUMBNAIL_GAP = 12;

export const FILES_TO_DISPLAY = {
  [ETSY]: MAX_NUMBER_OF_FILES[ETSY],
};

export const VIDEOS_TO_DISPLAY = {
  [EBAY]: MAX_NUMBER_OF_VIDEOS[ETSY],
  [ETSY]: MAX_NUMBER_OF_VIDEOS[ETSY],
  [SHOPIFY]: 8,
};

export const MESSAGES = {
  CUSTOM_SHIPPING_OPTIONS: 'Custom shipping options',
  DEFINED_BY_VARIATION: 'Defined by Variation',
  INSTRUCTIONS: 'Example: Enter the name you want on the necklace. Max 12 characters, no\nspaces, no special characters. Thank you!',
  NOT_AVAILABLE: 'Not available',
  NOT_SUPPORTED: 'Not supported',
  NO_RESULTS_FOUND: 'No results found',
  PUBLISH_PROHIBITED: 'prohibited this listing from being published',
  REFRESH_SHOP_FOR_PERSONALIZATION: 'Click "Refresh shop" to import your personalizations from Etsy and edit them in Vela',
  UPLOAD_NOT_SUPPORTED: 'Digital files cannot be included for "Made to Order" listings. Upload files after purchase to complete the order.',
  WHEN_YOU_MADE_IT: 'When did you make it?',
};

export const PLACEHOLDERS = {
  [ATTRIBUTE.ALT_TEXT]: 'Alt text',
  [ATTRIBUTE.BARCODE]: 'Barcode',
  [ATTRIBUTE.CAP]: 'CAP',
  [ATTRIBUTE.CASE_SIZE]: 'Case size',
  [ATTRIBUTE.CATEGORY]: 'Choose Category',
  [ATTRIBUTE.CHAR_COUNT_MAX]: 'Limit',
  [ATTRIBUTE.COLLECTIONS]: 'Choose Collections',
  [ATTRIBUTE.CONDITION]: 'Choose Condition',
  [ATTRIBUTE.COUNTRY]: 'Choose country',
  [ATTRIBUTE.COUNTRY_CODE]: 'Choose country/region',
  [ATTRIBUTE.CPI]: 'CPI',
  [ATTRIBUTE.DEADLINE_DATE]: 'Deadline to order',
  [ATTRIBUTE.DEPTH]: 'Depth',
  [ATTRIBUTE.DESCRIPTION]: 'Description',
  [ATTRIBUTE.END_DATE]: 'End ship date',
  [ATTRIBUTE.HEIGHT]: 'Height',
  [ATTRIBUTE.HS_CODE]: 'HS Code',
  [ATTRIBUTE.GTIN]: 'GTIN',
  [ATTRIBUTE.INSTRUCTIONS]: 'Instructions',
  [ATTRIBUTE.IS_SUPPLY]: 'What is it?',
  [ATTRIBUTE.LENGTH]: 'Length',
  [ATTRIBUTE.LOCATION]: 'Location',
  [ATTRIBUTE.MATERIALS]: 'Materials',
  [ATTRIBUTE.MINIMUM_ORDER_QUANTITY]: 'Minimum order quantity',
  [ATTRIBUTE.PAGE_TITLE]: 'Page title',
  [ATTRIBUTE.PAYMENT_POLICY]: 'Choose Payment policy',
  [ATTRIBUTE.POSTAL_CODE]: 'Postal code',
  [ATTRIBUTE.PRICE]: 'Price',
  [ATTRIBUTE.PROCESSING_PROFILE]: 'Choose Processing profile',
  [ATTRIBUTE.PRODUCTION_PARTNERS]: 'Choose Production partner',
  [ATTRIBUTE.PRODUCT_TYPE]: 'Choose Product type',
  [ATTRIBUTE.PROFILE_ID]: 'Choose Shipping profile',
  [ATTRIBUTE.RESTOCK_DATE]: 'Restock date',
  [ATTRIBUTE.RETAIL_PRICE]: 'Retail price',
  [ATTRIBUTE.RETURN_POLICY]: 'Choose Return policy',
  [ATTRIBUTE.QUANTITY]: 'Quantity',
  [ATTRIBUTE.SECTION]: 'Choose Section',
  [ATTRIBUTE.SHIPPING_POLICY]: 'Choose Shipping policy',
  [ATTRIBUTE.SKU]: 'SKU',
  [ATTRIBUTE.START_DATE]: 'Start ship date',
  [ATTRIBUTE.TAGS]: 'Tags',
  [ATTRIBUTE.TARIFF_CODE]: 'Tariff code',
  [ATTRIBUTE.TITLE]: 'Title',
  [ATTRIBUTE.VENDOR]: 'Choose Vendor',
  [ATTRIBUTE.WEIGHT]: 'Weight',
  [ATTRIBUTE.WHEN_MADE]: 'When was it made?',
  [ATTRIBUTE.WHO_MADE]: 'Who made it?',
  [ATTRIBUTE.WHOLESALE_PRICE]: 'Wholesale price',
  [ATTRIBUTE.WIDTH]: 'Width',
  ADD_OPTION: 'Add option',
  CENTS: '¢',
  FIELD_TYPE: 'Choose field type',
  FIND: 'Find',
  INSTRUCTION: 'Enter additional instruction',
  INSTRUCTIONS: 'Instructions',
  LIMIT: 'Limit',
  PROFILE: 'Choose Profile',
  PROMPT: 'Choose prompt',
  REPLACE: 'Replace',
  SCALE: 'Choose Scale',
  TITLE: 'Title',
  UNIT: 'Choose a unit',
};

export const TAG = {
  AI: 'ai',
  DELETE: 'delete',
  ERROR: 'error',
  NEW: 'new',
  PRODUCT: 'product',
  READONLY: 'readonly',
};

export const FORM = {
  DESCRIPTION: ATTRIBUTE.DESCRIPTION,
  DETAILS: 'details',
  FILES: ATTRIBUTE.FILES,
  INVENTORY: 'inventory',
  PERSONALIZATION: ATTRIBUTE.PERSONALIZATION,
  PHOTOS: ATTRIBUTE.PHOTOS,
  VIDEOS: ATTRIBUTE.VIDEOS,
  PRICING: 'pricing',
  SEO: ATTRIBUTE.SEO,
  SHIPPING: ATTRIBUTE.SHIPPING,
  TAGS: ATTRIBUTE.TAGS,
  TITLE: ATTRIBUTE.TITLE,
  VARIATIONS: ATTRIBUTE.VARIATIONS,
};

export const FORMS = [
  FORM.PHOTOS,
  FORM.VIDEOS,
  FORM.TITLE,
  FORM.DESCRIPTION,
  FORM.TAGS,
  FORM.DETAILS,
  FORM.PRICING,
  FORM.INVENTORY,
  FORM.VARIATIONS,
  FORM.PERSONALIZATION,
  FORM.SHIPPING,
  FORM.FILES,
  FORM.SEO,
];

export const FORMS_WITH_VELA_TAB = Set([
  FORM.PHOTOS,
  FORM.TITLE,
  FORM.DESCRIPTION,
  FORM.INVENTORY,
  FORM.PRICING,
  FORM.TAGS,
  FORM.VARIATIONS,
]);

export const FORM_TITLE = {
  [FORM.DESCRIPTION]: 'Description',
  [FORM.DETAILS]: 'Details',
  [FORM.FILES]: 'Digital files',
  [FORM.INVENTORY]: 'Inventory',
  [FORM.PERSONALIZATION]: 'Personalization',
  [FORM.PHOTOS]: 'Photos',
  [FORM.VIDEOS]: 'Video',
  [FORM.PRICING]: 'Price',
  [FORM.SHIPPING]: 'Shipping',
  [FORM.TAGS]: 'Tags',
  [FORM.TITLE]: 'Title',
  [FORM.VARIATIONS]: 'Variations',
  [FORM.SEO]: 'Search engine listing',
};
